<template>
  <el-table-column
    prop="latest_payment_date"
    sortable="custom"
    label="Kiegyenlítve"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.latest_payment_date && scope.row.latest_payment_date !== '0000-00-00' && !scope.row.is_expired"
      >
        {{ scope.row.latest_payment_date | date }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'latest_payment_date',
};
</script>
